import { FCC } from "types";

export const TextContainer: FCC = ({ children }) => (
  <p className="text-lg h-7 text-primary-100 font-semibold">
    {children || "-"}
  </p>
);
